import { api } from '../HttpService.js'

export const fetchPlans = async () =>  await api.integrations.get(`/omie/plans/`)